import { render, staticRenderFns } from "./orderslist.vue?vue&type=template&id=e21a89e2&"
import script from "./orderslist.vue?vue&type=script&lang=js&"
export * from "./orderslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports